import { ChangeDetectionStrategy, Component, model, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpStatusEnum } from '@core/api';
import { TranslateModule } from '@ngx-translate/core';
import { CharacterCounterComponent } from '@shared/components';
import { AutoFocusModule } from 'primeng/autofocus';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DashboardApi } from '../../_core/api';

@Component({
    selector: 'app-request-quote-for-custom-work-modal',
    standalone: true,
    imports: [
        DialogModule,
        TranslateModule,
        AutoFocusModule,
        ButtonModule,
        CharacterCounterComponent,
        InputTextareaModule,
        FormsModule,
    ],
    templateUrl: './request-quote-for-custom-work-modal.component.html',
    styleUrls: ['./request-quote-for-custom-work-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestQuoteForCustomWorkModalComponent {
    readonly isVisible = model.required<boolean>();

    readonly descriptionMaxLength = 1000;
    readonly descriptionMinLength = 50;

    readonly description = signal('');
    readonly isLoading = signal(false);

    constructor(private dashboardApi: DashboardApi) {}

    onCloseModal() {
        this.description.set('');
        this.isVisible.set(false);
    }

    async onSubmitInquiry() {
        this.isLoading.set(true);
        const response = await this.dashboardApi.requestCustomQuote(this.description());
        if (response.status === HttpStatusEnum.SUCCESS) this.onCloseModal();
        this.isLoading.set(false);
    }
}
